import axios from 'axios';
import { getTokenLocalStorage } from '@core/services';

const api = axios.create({
    baseURL: window._env_.API_URL,
    timeout: window._env_.API_TIMEOUT
});

api.interceptors.request.use(
    (config) => {
        if (config.url !== '/api/auth/signin') {
					config.headers = config.headers || {}
					config.headers['Authorization'] = `Bearer ${getTokenLocalStorage()}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;
